/* BONODER - suggestions de la barre de recherche du header.
   Le theme rend le markup <predictive-search> et la section predictive-search,
   mais aucun fichier ne definit le composant : rien ne va chercher les suggestions.
   Ce fichier redefinit le composant en visant le markup et le CSS deja en place
   (attributs open / loading, [data-predictive-search], .predictive-search-status). */
(function () {
  'use strict';

  if (!('customElements' in window)) return;
  if (customElements.get('predictive-search')) return;

  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 220;
  var CACHE = {};

  class BdPredictiveSearch extends HTMLElement {
    connectedCallback() {
      if (this.bdReady) return;
      this.bdReady = true;

      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-search]');
      this.statusEl = this.querySelector('.predictive-search-status');
      this.resetButton = this.querySelector('button[type="reset"]');
      if (!this.input || !this.results) return;

      this.loadingMarkup = this.results.innerHTML;
      this.timer = null;
      this.controller = null;

      this.onInput = this.onInput.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);

      this.input.addEventListener('input', this.onInput);
      this.input.addEventListener('focus', this.onFocus);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('click', this.onDocumentClick);

      if (this.resetButton) {
        this.resetButton.addEventListener('click', function () {
          this.input.value = '';
          this.close(true);
          this.input.focus();
        }.bind(this));
      }

      if (this.form) {
        this.form.addEventListener('submit', function () { this.close(false); }.bind(this));
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    get query() {
      return (this.input.value || '').trim();
    }

    get suggestUrl() {
      var base = (this.form && this.form.getAttribute('action')) || '/search';
      return base + '/suggest';
    }

    onInput() {
      clearTimeout(this.timer);
      var q = this.query;
      if (q.length < MIN_CHARS) {
        this.close(true);
        return;
      }
      this.timer = setTimeout(function () { this.search(q); }.bind(this), DEBOUNCE_MS);
    }

    onFocus() {
      var q = this.query;
      if (q.length < MIN_CHARS) return;
      if (CACHE[q]) this.render(CACHE[q]);
      else this.search(q);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) this.close(false);
    }

    onKeydown(event) {
      var key = event.key;
      if (key === 'Escape' || key === 'Esc') {
        this.close(true);
        this.input.focus();
        return;
      }
      if (key !== 'ArrowDown' && key !== 'ArrowUp') return;
      if (!this.hasAttribute('open')) return;

      var items = Array.prototype.slice.call(
        this.results.querySelectorAll('a[href], button:not([type="reset"])')
      ).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;

      event.preventDefault();
      var current = items.indexOf(document.activeElement);
      var next;
      if (key === 'ArrowDown') next = current < 0 ? 0 : Math.min(current + 1, items.length - 1);
      else next = current <= 0 ? -1 : current - 1;

      if (next < 0) this.input.focus();
      else items[next].focus();
    }

    search(q) {
      if (CACHE[q]) { this.render(CACHE[q]); return; }

      this.setAttribute('loading', '');
      this.setAttribute('open', '');
      this.input.setAttribute('aria-expanded', 'true');
      this.announce(this.getAttribute('data-loading-text') || '');

      if (this.controller) { try { this.controller.abort(); } catch (e) {} }
      this.controller = ('AbortController' in window) ? new AbortController() : null;

      var url = this.suggestUrl + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search';
      var opts = this.controller ? { signal: this.controller.signal } : {};

      fetch(url, opts)
        .then(function (response) {
          if (!response.ok) throw new Error('search');
          return response.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          var markup = section ? section.innerHTML : text;
          CACHE[q] = markup;
          if (this.query === q) this.render(markup);
        }.bind(this))
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          this.close(true);
        }.bind(this));
    }

    render(markup) {
      this.results.innerHTML = this.loadingMarkup + markup;
      this.removeAttribute('loading');
      this.setAttribute('open', '');
      this.input.setAttribute('aria-expanded', 'true');

      var count = this.results.querySelectorAll('li').length;
      this.announce(count ? count + ' suggestions' : 'Aucune suggestion');
    }

    close(clearResults) {
      clearTimeout(this.timer);
      if (this.controller) { try { this.controller.abort(); } catch (e) {} }
      this.removeAttribute('open');
      this.removeAttribute('loading');
      this.input.setAttribute('aria-expanded', 'false');
      if (clearResults) {
        this.results.innerHTML = this.loadingMarkup;
        this.announce('');
      }
    }

    announce(message) {
      if (!this.statusEl) return;
      this.statusEl.textContent = message;
      if (message) this.statusEl.removeAttribute('aria-hidden');
      else this.statusEl.setAttribute('aria-hidden', 'true');
    }
  }

  customElements.define('predictive-search', BdPredictiveSearch);
})();